import { render, staticRenderFns } from "./ExpeditionTeamDisclaimer.vue?vue&type=template&id=cea80a78&"
import script from "./ExpeditionTeamDisclaimer.ts?vue&type=script&lang=ts&"
export * from "./ExpeditionTeamDisclaimer.ts?vue&type=script&lang=ts&"
import style0 from "./ExpeditionTeamDisclaimer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports